/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProposalStatus {
  Pending = 0,
  Active = 1,
  Accepted = 2,
  Archived = 3,
  Draft = 4,
}
